import React, { useEffect, useMemo } from 'react';
import { unzipWith, sortBy, isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { useSetAtom, useAtomValue } from 'jotai';
import { filterNAMetricsAtom } from '@src/atoms/page';
import { currentMetricsMetaSelector } from '@store/common/selectors';
import { updateExportDataAtom } from './atom';

// TODO: multi series
// clean up after moving chart calls to query instead of redux
function useSetChartExport({ pageKey, sectionKey, widgetKey, widgetInfo, data = {}, totals = {} }) {
  const currentMetricsMeta = useSelector(currentMetricsMetaSelector);
  const metricsToNA = useAtomValue(filterNAMetricsAtom);
  const updateExportData = useSetAtom(updateExportDataAtom);

  const { headers, flatData, footerData } = useMemo(() => {
    const headers: any = [{ key: 'timestamp', title: 'Timestamp', type: 'timestamp' }];
    const footerDataRow: any = !isEmpty(totals) ? ['Total'] : [];
    const metrics = sortBy(
      Object.keys(data).map((m) => currentMetricsMeta[m]),
      ['displayName'],
    );
    let flatData: any = [];

    try {
      const metricsData = metrics.map(({ name: metric, displayName, unit }) => {
        headers.push({ key: metric, title: displayName + (unit === '' ? '' : ` (${unit})`) });
        footerDataRow.push(totals?.[metric]);
        if (metricsToNA.includes(metric)) {
          return data[metric].map((d: any) => [d.timestamp, 'NA']);
        }
        return data[metric];
      });
      // time + metrics
      flatData = unzipWith(metricsData, (...group) => {
        return [group[0][0], ...group.map((g) => g[1])];
      });
    } catch (err) {
      // pass
    }

    return { headers, flatData, footerData: [footerDataRow] };
  }, [data]);

  useEffect(() => {
    const path = ['sections', sectionKey, widgetKey];
    updateExportData({
      action: '$set',
      path,
      data: { widgetInfo, headers, data: flatData, footerData },
    });
    return () => {
      updateExportData({ action: '$unset', path });
    };
  }, [sectionKey, widgetKey, headers, flatData, footerData, widgetInfo, updateExportData]);
}

export default useSetChartExport;
